import type { Schema } from '@/api/client'

/** One line for a read-only row: `Posts newer than 3 days · 12 phrases skipped`. */
export function summariseDiscoveryRules(filter: Schema<'DiscoveryFilterOut'>): string {
  const hours = filter.max_age_hours
  const age =
    hours % 24 === 0 && hours > 24 ? `${String(hours / 24)} days` : `${String(hours)} hours`
  const n = filter.exclude_phrases.length
  return `Posts newer than ${age} · ${String(n)} ${n === 1 ? 'phrase' : 'phrases'} skipped`
}
